import CellBordersContainer from './CellBordersContainer';

export default CellBordersContainer;